export const CLASSIFIER_LOADED = '@@mah-maps/CLASSIFIER_LOADED';